<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>TFTP</h4>
        <small>Current Directory: {{ server_objects.root }}</small>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <form enctype="multipart/form-data">
          <div class="input-group mb-3">
            <div class="custom-file">
              <input type="file" class="custom-file-input" @change="filesChange($event)" multiple>
              <label class="custom-file-label">{{ upload_files_label }}</label>
            </div>
            <div class="input-group-append">
              <span class="input-group-text" @click="upload()">Upload</span>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <ul class="list-group list-group-flush">
          <li class="list-group-item" @click="openDir(-1)">
            <i class="fa fa-level-up-alt"></i> Up one level
          </li>
          <li v-for="directory in server_objects.dirs" :key="directory" class="list-group-item" @click="openDir(directory)">
            <i class="fa fa-folder"></i> {{ directory }}
          </li>
          <li v-for="file in server_objects.files" :key="file" class="list-group-item">
            <input type="checkbox" class="form-check-input" :value="file" v-model="checked_files">
            <div @click="openFile(file)">
              <i class="fa fa-file"></i> {{ file }}
            </div>
          </li>
        </ul>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-8">
        <button type="button" class="btn btn-light" @click="deleteFiles">Delete Selected Files</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: function () {
    return {
      upload_files_label: '',
      upload_files: [],
      checked_files: []
    }
  },
  computed: {
    ...mapGetters({
      server_objects: 'allServerObjects',
      scoped_site_id: 'scopedSiteId'
    })
  },
  created () {
    this.$store.dispatch('getServerObjects', '/tftp')
  },
  methods: {
    filesChange (event) {
      if (event.target.files.length > 1) {
        this.upload_files_label = 'Multiple Files Selected'
      } else if (event.target.files.length > 0) {
        this.upload_files_label = event.target.files[0].name
      } else {
        this.upload_files_label = ''
      }

      this.upload_files = event.target.files
    },
    upload () {
      this.$store.dispatch('uploadServerObjects', {
        files: this.upload_files,
        directory: this.server_objects.root
      })
      this.upload_files_label = ''
      this.upload_files = []
    },
    deleteFiles () {
      if (this.checked_files.length > 0) {
        this.$store.dispatch('deleteServerObjects', {
          checked_files: this.checked_files,
          directory: this.server_objects.root
        })
        this.checked_files = []
      } else {
        alert('Must select at least one file')
      }
    },
    openDir (directory) {
      let newRoot = this.server_objects.root

      if (directory === -1) {
        newRoot = newRoot.substring(0, newRoot.lastIndexOf('/'))
      } else {
        newRoot += '/' + directory
      }
      this.$store.dispatch('getServerObjects', newRoot)
    },
    openFile (file) {
      let filePath = this.server_objects.root + '/' + file
      this.$router.push({ name: 'AdminMachineTFTPFileEdit', params: { file_path: filePath } })
    }
  }
}
</script>

<style scoped>
</style>
